import { render, staticRenderFns } from "./send-table.vue?vue&type=template&id=86991d4e&scoped=true&"
import script from "./send-table.vue?vue&type=script&lang=js&"
export * from "./send-table.vue?vue&type=script&lang=js&"
import style0 from "./send-table.vue?vue&type=style&index=0&id=86991d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86991d4e",
  null
  
)

export default component.exports